import { render } from "./GenericPageHeader.vue?vue&type=template&id=7dbe03e8&scoped=true"
import script from "./GenericPageHeader.vue?vue&type=script&lang=js"
export * from "./GenericPageHeader.vue?vue&type=script&lang=js"

import "./GenericPageHeader.vue?vue&type=style&index=0&id=7dbe03e8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dbe03e8"]])

export default __exports__